import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import styled from 'styled-components';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SliderContainer = styled.div`
  width: 100%;
  height: 100vh;
  position: relative; /* Necesario para posicionar las flechas */
  background-color: #1a1a1a; /* Fondo oscuro para transiciones */
`;

const SlideWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex !important;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;

  /* Fondo borroso */
  &:before {
    content: '';
    position: absolute;
    top: -5%;
    left: -5%;
    width: 110vw;
    height: 110vh;
    background-image: url(${props => props.bgImage});
    background-size: cover;
    background-position: center;
    filter: blur(15px) brightness(0.5);
    z-index: 1;
  }
`;

const SlideImage = styled.img`
  position: relative;
  z-index: 2;
  max-width: 98vw;
  max-height: 90vh;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  margin: auto;
  display: block;
`;

const StyledSlider = styled(Slider)`
  height: 100%;
  width: 100%;

  .slick-prev, .slick-next {
    z-index: 10;
    width: 45px;
    height: 45px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    transition: background 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.6);
    }
  }

  .slick-prev {
    left: 25px;
  }

  .slick-next {
    right: 25px;
  }

  .slick-prev:before, .slick-next:before {
    color: white;
    font-size: 20px;
  }

  .slick-dots {
    bottom: 15px;
  }

  .slick-dots li button:before {
    font-size: 12px;
    color: #fff;
    opacity: 0.5;
  }

  .slick-dots li.slick-active button:before {
    opacity: 1;
  }
`;

const LiveOverlay = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 20;
  width: 300px;
background: rgba(255, 255, 255, 0.75);

  border-radius: 16px;
  padding: 14px 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,.35);
  color: white;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 768px) {
    display: none;
  }
`;
const LiveMobileCTA = styled.a`
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 30;

  background: rgba(255, 255, 255, 0.95);
  color: #40A4AE;
  padding: 10px 16px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  box-shadow: 0 6px 20px rgba(0,0,0,.35);

  display: none;
  align-items: center;
  gap: 10px;

  img {
    height: 26px;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;


const LiveTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;


const LiveTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #40A4AE;
font-weight: 700;


`;

const LiveLogos = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  img {
    object-fit: contain;
  }

  .inpro {
    height: 40px;
  }

  .lu {
    height: 61px; /* más grande a propósito */
  }
`;



const LiveText = styled.div`
  align-self: center;

  font-size: 13px;
  line-height: 1.3;
`;

const LiveButton = styled.a`
  align-self: center;
background: #40A4AE;
color: white;

  padding: 7px 14px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(0,0,0,.25);

&:hover {
  background: #B91C1C;
}
`;

const isLiveVisible = () => {
  const now = new Date();

  // Próximo lunes a las 00:00
  const monday = new Date(now);
  const day = now.getDay(); // 0=domingo, 6=sábado
  const daysUntilMonday = (8 - day) % 7 || 7;

  monday.setDate(now.getDate() + daysUntilMonday);
  monday.setHours(0, 0, 0, 0);

  return now < monday;
};


const ImageSlider = () => {
  const [slides, setSlides] = useState([]);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const url = isMobile
          ? 'https://us-central1-inprojuy-f1173.cloudfunctions.net/app/ultimos-sliders?mobile=true'
          : 'https://us-central1-inprojuy-f1173.cloudfunctions.net/app/ultimos-sliders';

        const response = await axios.get(url);
        setSlides(response.data);
      } catch (error) {
        console.error('Error fetching slides:', error);
      }
    };

    fetchSlides();
  }, [isMobile]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <SliderContainer>

      {/* CTA TRANSMISIÓN EN VIVO */}
    {/*   {isLiveVisible() && (
        <LiveOverlay>
          <LiveTop>
            <LiveLogos>
              <img className="inpro" src="/img/inprojuylogo1.png" alt="INPROJUY" />
              <img className="lu" src="https://loteria.chaco.gov.ar/uploads/resources/5c5978341c6d8683780791.png" alt="Lotería Unificada" />
            </LiveLogos>

            <LiveTitle>
              🔴 TRANSMISIÓN OFICIAL
            </LiveTitle>


          </LiveTop>



          <LiveButton
            href="#/sorteo-en-vivo"
            target="_blank"
            rel="noopener noreferrer"
          >
            VER SORTEO EN VIVO
          </LiveButton>
        </LiveOverlay>
      )}
      {isLiveVisible() && (
        <LiveMobileCTA
          href="#/sorteo-en-vivo"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://loteria.chaco.gov.ar/uploads/resources/5c5978341c6d8683780791.png"
            alt="Lotería Unificada"
          />
          🔴 SORTEO EN VIVO
        </LiveMobileCTA>
      )} */}



      <StyledSlider {...settings}>
        {slides.map(slide => (
          <div key={slide.id}>
            <SlideWrapper bgImage={slide.imagen}>
              {slide.link ? (
                <a href={slide.link} target="_blank" rel="noopener noreferrer">
                  <SlideImage src={slide.imagen} alt={slide.Slider} />
                </a>
              ) : (
                <SlideImage src={slide.imagen} alt={slide.Slider} />
              )}
            </SlideWrapper>
          </div>
        ))}
      </StyledSlider>

    </SliderContainer>
  );

}
export default ImageSlider;
